export default __webpack_public_path__ + "static/media/qrcode-site-1440w.cc54c1a4.png";